<div *ngIf="isGenerating">
    <div class="loader is-active padding-leader-3 padding-trailer-3">
        <div class="loader-bars"></div>
        <div class="loader-text">Loading...</div>
    </div>
</div>
<div class="alert alert-red is-active container" *ngIf="error">
    {{ errorMessage }}
</div>
<div class="bootstrap-wrapper">
    <div *ngIf="!error && reportData" id="onemap-report">
        <div class="reportSectionHeader">
            Project Detail Report
        </div>
        <!-- Title Section -->
        <div class="reportSection">
            <div class="reportSectionHeader">
                <label>Project ID:&nbsp;</label>{{ reportData.projectDetail.projectId }}
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-12">
                        <label>Title:&nbsp;</label>{{ reportData.projectDetail.projectTitle }}
                    </div>
                </div>
            </div>
        </div>
        <!-- Location Section -->
        <div class="reportSection">
            <div class="reportSectionHeader">
                Location
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-4">
                        <label>County:&nbsp;</label>{{ reportData.projectDetail.ctyCode }}
                    </div>
                    <div class="col-xs-4">
                        <label>Route:&nbsp;</label>{{ reportData.projectDetail.stRtNo }}
                    </div>
                    <div class="col-xs-4">
                        <label>Juris:&nbsp;</label>{{ reportData.projectDetail.juris }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <label>Location Description:&nbsp;</label>{{ reportData.projectDetail.geographicDescription }}
                    </div>
                </div>
            </div>
        </div>
        <!-- Project Status Section -->
        <div class="reportSection">
            <div class="reportSectionHeader">
                Project Status
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-6">
                        <label>Status:&nbsp;</label>{{ reportData.projectDetail.projectStatus }}
                    </div>
                    <div class="col-xs-6">
                        <label>Let Date:&nbsp;</label><span *ngIf="reportData.projectDetail.letDate">
                            {{ reportData.projectDetail.letDate.substring(4,6) }}/{{ reportData.projectDetail.letDate.substring(6) }}/{{ reportData.projectDetail.letDate.substring(0,4) }}
                            &nbsp;({{ reportData.projectDetail.physicallY_READY }})
                        </span>

                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Primary Improvement Type:&nbsp;</label>{{ reportData.projectDetail.improvementType }}
                    </div>
                    <div class="col-xs-6">
                        <label>Notice to Proceed Date:&nbsp;</label><span *ngIf="reportData.projectDetail.ntpDate">
                            {{ reportData.projectDetail.ntpDate.substring(4,6) }}/{{ reportData.projectDetail.ntpDate.substring(6) }}/{{ reportData.projectDetail.ntpDate.substring(0,4) }}
                            &nbsp;({{ reportData.projectDetail.physicallY_READY }})
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Planning Partner:&nbsp;</label>{{ reportData.projectDetail.planningPartnerShortName }}
                    </div>
                    <div class="col-xs-6">
                        <label>Physical Completion:&nbsp;</label><span *ngIf="reportData.projectDetail.physicaL_DATE">{{ reportData.projectDetail.physicaL_DATE.substring(4,6) }}/{{ reportData.projectDetail.physicaL_DATE.substring(6) }}/{{ reportData.projectDetail.physicaL_DATE.substring(0,4) }}&nbsp;({{ reportData.projectDetail.physicallY_READY }})</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Open Date:&nbsp;</label><span *ngIf="reportData.projectDetail.opeN_DATE">{{ reportData.projectDetail.opeN_DATE.substring(4,6) }}/{{ reportData.projectDetail.opeN_DATE.substring(6) }}/{{ reportData.projectDetail.opeN_DATE.substring(0,4) }}</span>
                    </div>
                    <div class="col-xs-6">
                        <label>Proposed TIP:&nbsp;</label>{{ reportData.projectDetail.tiP_PROPOSED_FLAG }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Approved TIP:&nbsp;</label>{{ reportData.projectDetail.tiP_FLAG }}
                    </div>
                    <div class="col-xs-6">
                        <label>Approved TYP:&nbsp;</label>{{ reportData.projectDetail.tyP_FLAG }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Obligation:&nbsp;</label>{{ reportData.projectDetail.obligatioN_PLAN_FLAG }}
                    </div>
                    <div class="col-xs-6">
                        <label>Phases in Current TIP:&nbsp;</label>{{ reportData.projectDetail.phasesOnTip }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <label>Is Decade of Investment:&nbsp;</label>{{ reportData.projectDetail.decadE_OF_INVESTMENT_FLAG }}
                    </div>
                </div>
            </div>
        </div>
        <!-- Legislative District Section -->
        <div class="reportSection">
            <div class="reportSectionHeader">
                Legislative District
            </div>
            <div class="reportSectionContent container">
                <table class="table" aria-label="Legislative District">
                    <thead>
                        <tr>
                            <th>PA House Districts</th>
                            <th>PA Senate Districts</th>
                            <th>US Congress Districts</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td *ngIf="districtInformation.house">
                                <a href="{{ districtInformation.house.url }}"
                                   target="blank">{{ reportData.projectDetail.housE_LEGISLATOR_NAMES }}</a>
                            </td>
                            <td *ngIf="districtInformation.senate">
                                <a href="{{ districtInformation.senate.url }}"
                                   target="blank">{{ reportData.projectDetail.senatE_LEGISLATOR_NAMES }}</a>
                            </td>
                            <td *ngIf="districtInformation.congress">
                                <a href="{{ districtInformation.congress.url }}"
                                   target="blank">{{ reportData.projectDetail.congresS_LEGISLATOR_NAMES }}</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="reportSection">
            <div class="reportSectionHeader">
                Project Locations
            </div>
            <div class="reportSectionContent container">
                <table class="row table" aria-label="Project Locations">
                    <thead>
                        <tr>
                            <th>Segment Begin</th>
                            <th>Offset Begin</th>
                            <th>Segment End</th>
                            <th>Offset End</th>
                            <th>Length</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of reportData.projectLocations">
                            <td>{{ row.segBgn }}</td>
                            <td>{{ row.offsetBgn }}</td>
                            <td>{{ row.segEnd }}</td>
                            <td>{{ row.offsetEnd }}</td>
                            <td>{{ row.segLength }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
